import { AddCircle, DoNotDisturbOnSVG } from "../../../../assets";
import { BulletList } from "./BulletList";

const loadingList = [{ text: "Loading..." }];

export const ProsAndCons = ({ strengths, concerns, isLoading }) => {
  if (!strengths || !concerns) return <></>;

  const mappedStrengths = strengths.map((item) => ({ text: item }));
  const mappedConcerns = concerns.map((item) => ({ text: item }));

  return (
    <div className="flex gap-2 flex-col sm:flex-row">
      <BulletList
        title="Strengths"
        premium
        list={isLoading ? loadingList : mappedStrengths}
        icon={<AddCircle />}
      />
      <BulletList
        title="Concerns"
        premium
        list={isLoading ? loadingList : mappedConcerns}
        icon={<DoNotDisturbOnSVG />}
      />
    </div>
  );
};
